import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { SummaryViewsManagementView } from "src/components/views/spc/masterData/summaryViews/SummaryViewsManagementView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/spc/summaryViews/")({
	staticData: { title: i18n.t("summary_views"), legacyViewKey: "summaryViewsPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <SummaryViewsManagementView />;
}
